var _defs, _path, _ellipse, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _path4, _rect6, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon2, _polygon3, _polygon4, _polygon5, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _polygon6, _polygon7, _polygon8, _polygon9, _rect7, _path43, _path44, _path45, _path46, _path47, _g, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "6968ac48-3a8f-41ea-a7fd-90e9ec00ee17",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 873.53,
    height: 801.44,
    viewBox: "0 0 873.53 801.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "70ce31e8-5126-44c6-9ded-adf44b0dced1",
    x1: 489.88,
    y1: 814.11,
    x2: 489.88,
    y2: 49.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "businessman") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M652.59,174.63c-47.88-1.66-93.48-17.11-137-34S428.89,105,382.16,96c-30.06-5.76-64.43-6.58-88.65,9.53-23.3,15.51-30.84,42.28-34.88,67.12-3,18.69-4.84,38.36,3.51,55.85,5.79,12.15,16.08,22.36,23.19,34,24.76,40.48,7.26,90.4-19.57,129.93-12.58,18.54-27.18,36.23-36.89,56s-14.21,42.35-5.71,62.49c8.42,20,28.49,34.94,50.23,45.49,44.16,21.41,96.19,27.54,146.93,31,112.32,7.68,225.23,4.36,337.85,1,41.67-1.24,83.53-2.49,124.53-8.93,22.77-3.58,46.28-9.26,62.81-23,21-17.41,26.18-46.88,12.12-68.71-23.59-36.61-88.79-45.71-105.28-85-9.07-21.63.25-45.72,13.43-65.77,28.29-43,75.7-80.78,78.2-130,1.72-33.77-21.08-67.6-56.32-83.59-36.94-16.75-88.17-14.64-115.42,13.09C744.18,165.12,694.86,176.1,652.59,174.63Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.25,
    cy: 760.32,
    rx: 303.97,
    ry: 41.12,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M632.51,258.88s-9.41-18.57-8.14-24.09-6.62-17.31-6.62-17.31l.51-19.56s-1.09,2-6.77,3.75c-.48-.63-1-1.25-1.54-1.84a40.32,40.32,0,0,0-6.82-5.69l-10-21.58-9.67-14.81s-15.25-31-31-37.84l-2.48-4.85a.38.38,0,0,0,.15-.49l-2.52-4.93a.39.39,0,0,0-.49-.18l-2.41-4.72a37.91,37.91,0,0,0-7-16.89c-.25-.35-.52-.67-.78-1l3.92-.14c3.44-.13,7.28-.43,9.59-3a8.77,8.77,0,0,0,1.79-3.3,14,14,0,0,0,.58-2.93c0-.15,0-.3,0-.44q0-.51,0-1c0-.27,0-.53,0-.8s0-.43,0-.64-.11-.69-.17-1c0-.13,0-.26-.08-.39a11.66,11.66,0,0,0-.31-1.16,1.55,1.55,0,0,1-.07-.23c-.14-.4-.29-.8-.46-1.19a1.11,1.11,0,0,1-.07-.16c-.18-.39-.38-.77-.59-1.14l-.06-.12v0a4,4,0,0,0-.25-.45c-2.71-4.26-7.47-6.75-12-9a138.69,138.69,0,0,0-13-6,70,70,0,0,0-51,.72,20.19,20.19,0,0,0-4.54,2.42,23.46,23.46,0,0,0-4.95,5.82l-7.75,11.45A16.18,16.18,0,0,0,455,78.79c-1.45,5.44,3.1,10.89,2.59,16.5-.26,2.79-1.76,5.35-2.05,8.14-.37,3.6,1.3,7.07,2.93,10.32l11.09,22c-.59,2.89-1.24,5.85-1.95,8.71h0c-5.11,5.28-6.83,8.16-7.3,9.72l-.15.08h0a9,9,0,0,0-2.56,2.5L447.06,167s-18.32,4.76-22.13,10.79c0,0-28.75-1.26-28.5,38.89,0,0-1.27,15.06-2,17.07s0,22.33,0,22.33l-.34,41.16s-1.1,21.83,0,29.61,2.37,37.39,2.37,37.39,6.87,28.86,4.33,39.15c-2.44,9.85,0,31.39,4,31.48.76,1.57,1.63,2.34,2.58,1.9a11,11,0,0,1,1.27-.46V460.9s-4.95,34.45.6,41c-3.68,5.24-8,14.18-9.1,16.53l-38.9-2.09-4.95,1.39h0L351.75,519,349,582.27l1.1.08-.08,1.93,2.6.19L349,648.19l53.85,4.43c-2.37,5.31-5.12,11-6.19,11.55-2,1-6.36-2-7.38-.76s-4.07,2.76-7.63,2-5.85,3.26-5.85,3.26.52.46,1.3,1.31c-5.78-.7-13.09,2.4-17.06,4.4-1.78.9-2.89,1.57-2.89,1.57H346.65l5.77,36.81,4.07,2.78,1,29s16.28,50.19,23.74,49.86a3.37,3.37,0,0,0,2.51-1.26c4-4.62,1.23-20.49,1.23-20.49V746.23s6.1-2.68,5.42-4.69,9.84-24,10.78-26a.17.17,0,0,0,.08-.16c0-2.26,4.58-4.77,4.32-5.77s11.2-7.28,12-12.8,8.39-2.51,8.39-2.51l9.66-11.1c.29,13.53.84,23,1.79,25.4,4.58,11.55,6.36,29.62,6.36,29.62s-2.8,13.8,0,18.32c1.72,2.76,5.72,5.72,8.5,8.17-2.89,8.76-2.48,27.38-2.48,27.38v10.7l21.37,6s.67-5.35,1.69-5.35,14.59,10.37,14.59,10.37,52.24.67,65.46,0c5-.25,6.36-2.4,5.59-5-1.27-4.33-8.4-9.94-14.74-10.37-10.18-.67-23.07-11.37-23.07-11.37s1-2.35-4.41-5.69c-3.74-2.3-14.09-11.61-20.49-17.06.3-.41.61-.82.9-1.26,0,0-8.65-12-6.86-17.32s-.77-13-.77-13-4.83-14.81-4.83-22.34c0-4.77-.72-31.9-1.24-51.14l4.46.37.09-1.92,2,.18,18.91,1.74-.58-20.21c9.11-4,16.69-7.71,19.83-10.08,10.68-8,19.84-8.53,19.84-8.53s21.62-11.54,24.93-16.31,3-39.4,3-39.4l-1.78-74.22v-.06s-1.52-35.88-4.58-43.66c-1.12-2.88-3.89-12.48-6.92-23.44a18.11,18.11,0,0,1,5.22.22c.11,2.68.18,4.52.18,5.15,0,4.26,6.1,7.88,6.1,7.88l-4.32-96V275.66c13.32,4.24,45.53,5.56,45.53,5.56C638.1,280,632.51,258.88,632.51,258.88ZM506.87,176.4l-.07,0a66.59,66.59,0,0,1,1.85-7.45ZM419.45,505.67c7.89,1.3,17,.92,17.69-.61.07-.15.16-.42.28-.77.25.44.49.89.74,1.35l-.77,14.48v.33l-26-1.4C413.21,511.3,416.65,507.52,419.45,505.67Zm86.67,73.06-.67-23.45c1.16-4.32,2.2-8.24,3.09-11.6.4,2.79.74,5.36,1,7.73C512,573.66,508.37,578,506.12,578.73Zm74-351.58c-1.49.57-7.16-3-12.54-6.7,0-.68.05-1.35.08-2,.76-15.31-24.17-24.84-31.8-26.6a27.41,27.41,0,0,1-5.36-2,125,125,0,0,1-11.84-6.69l.1-.29s-9.84-6.23-10.05-14a132.92,132.92,0,0,1,8.46-20.53c.19-.39.4-.8.6-1.19a39.25,39.25,0,0,0,12.8-6.78c1.53,20,30.47,37.21,30.47,37.21l3.09,5,.73,1.18c-1.56.92-2.31,1.66-1.78,2.09,2.2,1.76,7.52,11.72,9.72,15.93a.06.06,0,0,0,0,0c.6,1.14,1,1.85,1,1.85s4.73,12.87,7.44,23.64A2,2,0,0,0,580.1,227.15Z",
    transform: "translate(-163.24 -49.28)",
    fill: "url(#70ce31e8-5126-44c6-9ded-adf44b0dced1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M591.3,175.28l-.34.45-1.16,1.55L567.55,193l-4.72-7.76-3-5S515.48,153.64,534.55,128s47.25,32.5,47.25,32.5Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffc5d3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 547.05,
    y: 112.1,
    width: 0.76,
    height: 6.26,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(-156.55 209.3) rotate(-26.73)",
    fill: "#3a3768"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 521.39,
    y: 119.37,
    width: 0.43,
    height: 2.06,
    rx: 0.21,
    ry: 0.21,
    transform: "translate(-161.64 198.23) rotate(-26.73)",
    fill: "#3a3768"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 523.41,
    y: 122.65,
    width: 0.48,
    height: 3.59,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-163.24 199.58) rotate(-26.73)",
    fill: "#3a3768"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 525.6,
    y: 126.97,
    width: 0.46,
    height: 3.62,
    rx: 0.23,
    ry: 0.23,
    transform: "translate(-164.96 201.03) rotate(-26.73)",
    fill: "#3a3768"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 528.35,
    y: 104.91,
    width: 25.4,
    height: 51.62,
    rx: 2.24,
    ry: 2.24,
    transform: "translate(-164.21 208.08) rotate(-26.73)",
    fill: "#3a3768"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M536.4,105.67a.9.9,0,0,0-.4,1.22l.08.17a.91.91,0,0,1-.4,1.23l-9.62,4.84a.9.9,0,0,1-1.22-.4l-.09-.17a.91.91,0,0,0-1.22-.41l-1.87.95a1.72,1.72,0,0,0-.77,2.33L541.33,156a1.75,1.75,0,0,0,2.34.77l16.78-8.45a1.75,1.75,0,0,0,.77-2.34l-20.45-40.59a1.74,1.74,0,0,0-2.34-.77Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 527.92,
    y: 109.31,
    width: 3.55,
    height: 0.72,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(-155.95 200.72) rotate(-26.73)",
    fill: "#e6e8ec"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 368.88,
    cy: 59.17,
    r: 0.41,
    fill: "#e6e8ec"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550.8,261.28,544.55,429s21-7,24.25-1.75-3.5-84-3.5-84Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#5f5570"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M550.8,261.28,544.55,429s21-7,24.25-1.75-3.5-84-3.5-84Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M551.8,814.11c-13,.67-64.33,0-64.33,0s-13.34-10.33-14.34-10.33-1.66,5.33-1.66,5.33l-21-6V792.45s-.67-30.35,5.66-31.67,34.34,0,34.34,0c1-.33,20,17.67,25.33,21s4.33,5.67,4.33,5.67,12.67,10.66,22.67,11.33c6.23.42,13.24,6,14.49,10.33C558.05,811.72,556.7,813.86,551.8,814.11Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#bc8487"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M551.8,814.11c-13,.67-64.33,0-64.33,0s-13.34-10.33-14.34-10.33-1.66,5.33-1.66,5.33l-21-6V792.66l19.66,7.12,15.67,9.33h71.49C558.05,811.72,556.7,813.86,551.8,814.11Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M493.43,798.45s16-15.33,26.7-11",
    transform: "translate(-163.24 -49.28)",
    stroke: "#000",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392.13,742.11c.67,2-5.33,4.67-5.33,4.67v26.33s2.72,15.81-1.21,20.42a3.29,3.29,0,0,1-2.46,1.25c-7.33.33-23.33-49.67-23.33-49.67l-1-28.89-4-2.77-5.67-36.67h10.34s1.09-.67,2.84-1.57c5-2.55,15.47-7,21.16-2.76L402.8,716S391.47,740.11,392.13,742.11Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#bc8487"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M385.59,793.53a3.29,3.29,0,0,1-2.46,1.25c-7.33.33-23.33-49.67-23.33-49.67l-1-28.89-4-2.77-5.67-36.67h10.34s1.09-.67,2.84-1.57l2.49,37.57,1.33,32.33S378.69,780.31,385.59,793.53Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M571.05,605.53c-3.25,4.75-24.5,16.25-24.5,16.25s-9,.5-19.5,8.5c-5.43,4.14-24.3,12.35-41.25,19.32-15.83,6.51-30,11.93-30,11.93l-16.32,19L427.05,695s-7.5-3-8.25,2.5-12,11.75-11.75,12.75-4.25,3.5-4.25,5.75-16.75-16.25-16.5-27.5-8.5-19-8.5-19,2.25-4,5.75-3.25,6.5-.75,7.5-2,5.25,1.75,7.25.75,10-20.75,10-20.75l31.17-20.91,62-41.56,2.86-1.92s8.25,3.78,4.9-27.19c-.65-6-1.74-13.29-3.4-22.17-10.25-54.75,26.5-61,26.5-61l32.25,10.75,7.75,12v.06l1.75,73.94S574.3,600.78,571.05,605.53Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#433a59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M485.55,640.53s.1,3.55.25,9.07c-15.83,6.51-30,11.93-30,11.93l-16.32,19c-.27-15.75-.21-36.21,0-57.18l62-41.56C493.81,610.22,485.55,640.53,485.55,640.53Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M572.3,492.28v.06l-48.5.94s-8.5,33.25-9.75,40.25c-.31,1.72-2.19,9.07-4.85,19.17-.65-6-1.74-13.29-3.4-22.17-10.25-54.75,26.5-61,26.5-61l32.25,10.75Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M444.55,401.53l-6.25,120s-4.5,176.25,0,187.75,6.25,29.5,6.25,29.5-2.75,13.75,0,18.25,11.5,9.5,11.25,12,26.75,16,40.75-5.5c0,0-8.5-12-6.75-17.25s-.75-13-.75-13S484.3,718.53,484.3,711s-1.75-70.5-1.75-70.5,27.25-100,28.5-107,9.75-40.25,9.75-40.25l51.5-1s-1.5-35.75-4.5-43.5-17.75-64.5-17.75-64.5Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#433a59"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "195.36 469.89 190.89 471.17 190.71 475.59 324.73 477.32 324.73 475.58 195.36 469.89",
    fill: "#7b728f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M516.68,151.15c-19.5,39.55-7.39,47.82-5.46,48.84-4.13-1.92-57.81-27.14-50.75-33.54,4.59-4.17,8.52-22.31,10.83-35.31,1.37-7.76,2.17-13.69,2.17-13.69l56.33,10.33C524.34,136.58,520,144.33,516.68,151.15Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffc5d3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M591,175.73l-1.16,1.55L567.55,193l-4.72-7.76c6.87-4,27.47-11,27.47-11Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M611.55,211.78c-2,7-35.75,0-35.75,0l-3.5-5.5s-.35-.7-.94-1.84a.06.06,0,0,1,0,0c-2.16-4.19-7.39-14.11-9.55-15.87-2.75-2.25,29.5-13.25,29.5-13.25l9.88,21.5a39.82,39.82,0,0,1,6.7,5.67C610.39,205.2,612.46,208.59,611.55,211.78Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#e5e8ef"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M555.55,215s20,15.78,23,14.64,51.5,31.61,51.5,31.61,5.5,21-17.25,22.25c0,0-48.25-2-50.25-9S555.55,215,555.55,215Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#5f5570"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M501.05,183.28l-21.75,22.5,30.5,194,12-7s31,13.75,33.5,1,1.81-63,1.81-63L553.05,240s-14.25-31.75-14.25-32.75-20.55-16.5-20.55-16.5l-9.7-7.5Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M501.05,180.28l-21.75,22.5,30.5,194,12-7s31,13.75,33.5,1,1.81-63,1.81-63L553.05,237s-14.25-31.75-14.25-32.75-20.55-16.5-20.55-16.5l-9.7-7.5Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#e5e8ef"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M502.3,183.53l-6,12.25,6,6.33s21.5,43.42,17.25,69.17l4.5,84.75,14.5,14.25L550.05,357l-5.5-77s-14.75-63.5-30.25-83.25l-4.5-17.5Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M502.3,181.53l-6,12.25,6,6.33s21.5,43.42,17.25,69.17l4.5,84.75,14.5,14.25L550.05,355l-5.5-77s-14.75-63.5-30.25-83.25l-4.5-17.5Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#bc8487"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M529.8,127.78c-5.46,8.8-9.76,16.55-13.12,23.37a38.45,38.45,0,0,1-10.9,1.57c-12.36,0-19.48-8.55-26.48-17.63-1.6-2.06-6.86-1.58-8-4,1.37-7.76,2.17-13.69,2.17-13.69Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M544.11,113.38a38.33,38.33,0,1,1-7.29-22.49A38.33,38.33,0,0,1,544.11,113.38Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffc5d3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M493.55,198.78l-31.5-38s-2.91-1.17,6.92-11.46c0,0,36.1,28.14,38.34,32.92S493.55,198.78,493.55,198.78Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M492.55,196.78l-31.5-38s-2.91-1.17,6.92-11.46c0,0,36.1,28.14,38.34,32.92S492.55,196.78,492.55,196.78Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#e5e8ef"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M572.3,438.63s-6-3.6-6-7.85-3-64.25-3-64.25-4.4-35.81-9-64.27v0c-2.7-16.77-5.47-31-7.43-33.82l-.08-.12c-5.25-6.75-4.25-39.75-37-88,.44.3,11.73,8.22,20,12.2a27.42,27.42,0,0,0,5.27,2c7.5,1.75,32,11.25,31.25,26.5s1.75,50.25,1.75,50.25V343Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#5f5570"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M611.55,211.78c-2,7-35.75,0-35.75,0l-3.5-5.5s-.35-.7-.94-1.84a.06.06,0,0,1,0,0,.67.67,0,0,1-.05-.12c19.61,1.37,30.54-.06,36.58-1.83C610.39,205.2,612.46,208.59,611.55,211.78Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M572.3,206.28s10.5,29,9,36.25,24.25,35.75,24.25,35.75l24.5-17s-9.25-18.5-8-24-6.5-17.25-6.5-17.25l.5-19.48S611.55,209,572.3,206.28Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#5f5570"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M536.82,90.89l-19,.72a21.16,21.16,0,0,0-5.5.69c-6.79,2.09-9.92,9.31-10.17,15.8s-4,13.76-11.27,14.33a2.81,2.81,0,0,1-2.07-.46,3.42,3.42,0,0,1-.88-1.77,38.7,38.7,0,0,0-4.78-10.68c-3,.54-5.22,3.39-6,6.37s-.57,6.12-.56,9.21a59.61,59.61,0,0,1-1.13,11.69,38.33,38.33,0,1,1,61.39-45.9Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M511.33,91.3a21.16,21.16,0,0,1,5.5-.69l23.07-.86c3.38-.13,7.15-.43,9.42-2.94a8.81,8.81,0,0,0,1.76-3.29,14.2,14.2,0,0,0-1.49-11.63c-2.67-4.25-7.35-6.72-11.81-9a137.23,137.23,0,0,0-12.77-6,68,68,0,0,0-50.1.72A20.22,20.22,0,0,0,470.45,60a23.05,23.05,0,0,0-4.86,5.8L458,77.24a15.75,15.75,0,0,0-2.39,4.62c-1.43,5.43,3,10.86,2.54,16.45-.26,2.78-1.73,5.33-2,8.11-.36,3.59,1.28,7,2.89,10.27l13.34,26.91a59.62,59.62,0,0,0,3.23-19.5c0-3.09-.26-6.23.56-9.21s3-5.83,6-6.37a38.57,38.57,0,0,1,4.79,10.68,3.38,3.38,0,0,0,.88,1.77,2.8,2.8,0,0,0,2.07.46c7.31-.57,11-7.77,11.27-14.33S504.54,93.39,511.33,91.3Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#8f7080"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.89 471.17 200.23 468.5 341.06 476.17 325.56 478.17 190.89 471.17",
    fill: "#7b728f"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.89 471.17 200.23 468.5 341.06 476.17 325.56 478.17 190.89 471.17",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.89 611.17 326.31 609.44 319.79 608.84 319.79 505.5 321.51 481.51 321.89 476.17 341.06 476.17 344.89 611.17",
    fill: "#7b728f"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.81 607.5 324.99 605.86 319.79 605.29 319.79 507.31 321.16 484.57 321.46 479.5 336.75 479.5 339.81 607.5",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M401.42,520.45s9.25-20.29,13.13-20.92,11,0,11,0l-.63,5.88s-9.5.75-12.5,16.62Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#7b728f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M401.42,520.45s9.25-20.29,13.13-20.92,11,0,11,0l-.63,5.88s-9.5.75-12.5,16.62Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M437.3,497.41s24.87,12.37,21.62,26.87l-13.5-.75s-6.5-21.62-11.62-22.75S437.3,497.41,437.3,497.41Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#7b728f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M529.8,301.53v.73l-.5,83.27s-12.75,70-16.25,72.75-80.25-4.75-80.25-4.75L398.05,219.28c-.25-40,28-38.75,28-38.75,3.75-6,21.75-10.75,21.75-10.75l10-9.75.32-.45a8.89,8.89,0,0,1,2.52-2.49h0c2.06-1.19,3.37.38,4.12,1.93a11.63,11.63,0,0,1,.78,2.27C506.05,191,529.8,301.53,529.8,301.53Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#5f5570"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M528.8,302.53v.73c-12.57-23-61-110.14-74.25-114.48l5.1-3.5s3.4-2-2.85-4c0,0-9.75,1.25-10-10.5l10.32-10.2,2.52-2.49h0l4.12,1.93a11.63,11.63,0,0,1,.78,2.27C505.05,192,528.8,302.53,528.8,302.53Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M529.8,301.53v.73c-12.57-23-61-110.14-74.25-114.48l5.1-3.5s3.4-2-2.85-4c0,0-9.75,1.25-10-10.5l10.32-10.2,2.52-2.49h0l4.12,1.93a11.63,11.63,0,0,1,.78,2.27C506.05,191,529.8,301.53,529.8,301.53Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#433a59"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M547.88,269.4l-.08-.12c-5.25-6.75-4.25-39.75-37-88,.44.3,11.73,8.22,20,12.2l-2.31,7.62,5,2.67Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M546.88,268.4l-.08-.12c-5.25-6.75-4.25-39.75-37-88,.44.3,11.73,8.22,20,12.2l-2.31,7.62,5,2.67Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#433a59"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M508.36,172.58l-2.05,8.66s1.5,8.67,10.49,9.42l1.45-4.13S508.55,180.31,508.36,172.58Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M508.36,171.58l-2.05,8.66s1.5,8.67,10.49,9.42l1.45-4.13S508.55,179.31,508.36,171.58Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#e5e8ef"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.19 477.57 326.31 609.44 319.79 608.84 319.79 505.5 321.51 481.51 332.19 477.57",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.23 528.5 188.23 599.83 324.23 611.17 330.19 477.57 192.23 528.5",
    fill: "#7b728f"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.23 536.17 191.89 473.17 331.19 479.57 324.56 546.17 189.23 536.17",
    opacity: 0.1
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.23 534.17 190.89 471.17 330.19 477.57 323.56 544.17 188.23 534.17",
    fill: "#7b728f"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 246.81,
    y: 534.25,
    width: 16.75,
    height: 19.5,
    fill: "#c3bbc8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M412.55,455.78l-2.5,6.75s-5.25,37,1.25,41.5,25.75,4.75,26.75,2.5,8-27.75,8-27.75,6.25,18.75,9.5,17.25-7.5-37.14-7.5-37.14Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffc5d3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M410.05,427.78v35.75s26.5,5,38-3.64c0,0-10.75-34.61-6.75-43.36S410.05,427.78,410.05,427.78Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M410.05,426.78v35.75s26.5,5,38-3.64c0,0-10.75-34.61-6.75-43.36S410.05,426.78,410.05,426.78Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#e5e8ef"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M407.05,217.53l-7,3.75s-1.25,15-2,17,0,22.25,0,22.25l-.34,41s-1.08,21.75,0,29.5S400,368.28,400,368.28s6.76,28.75,4.26,39,.25,33.25,4.5,31.25,43.5-9.75,45.5-11.25,1-15.5,0-17.25-7-25.5-6.5-31-1.75-53.75-1.75-53.75,3.75-51.5,5.25-63.5-3-47.25-7-47.75S428.55,186.28,407.05,217.53Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M405.05,215.53l-7,3.75s-1.25,15-2,17,0,22.25,0,22.25l-.34,41s-1.08,21.75,0,29.5S398,366.28,398,366.28s6.76,28.75,4.26,39,.25,33.25,4.5,31.25,43.5-9.75,45.5-11.25,1-15.5,0-17.25-7-25.5-6.5-31-1.75-53.75-1.75-53.75,3.75-51.5,5.25-63.5-3-47.25-7-47.75S426.55,184.28,405.05,215.53Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#5f5570"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.66,104.77c-3,.54-5.22,3.39-6,6.37s-.57,6.12-.56,9.21a59.61,59.61,0,0,1-3.22,19.5l-13.35-26.91c-.26-.53-.53-1.08-.79-1.63a36.37,36.37,0,0,0,2.29,5.38l13.35,26.91a59.61,59.61,0,0,0,3.22-19.5c0-3.09-.25-6.23.56-9.21s3-5.83,6-6.37a40.13,40.13,0,0,1,2.59,4.73A39,39,0,0,0,480.66,104.77Z",
    transform: "translate(-163.24 -49.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.83,72.32a14.16,14.16,0,0,1-.24,7.45,8.83,8.83,0,0,1-1.77,3.29c-2.27,2.51-6,2.81-9.42,2.94l-23.06.86a21.23,21.23,0,0,0-5.51.69c-6.78,2.09-9.92,9.31-10.17,15.8s-4,13.76-11.27,14.33a2.81,2.81,0,0,1-2.07-.46h0c.23.65.45,1.31.64,2a3.3,3.3,0,0,0,.87,1.77,2.81,2.81,0,0,0,2.07.46c7.32-.57,11-7.77,11.27-14.33s3.39-13.71,10.17-15.8a21.23,21.23,0,0,1,5.51-.69l23.06-.86c3.38-.13,7.15-.43,9.42-2.94a8.83,8.83,0,0,0,1.77-3.29A14.2,14.2,0,0,0,549.83,72.32Z",
    transform: "translate(-163.24 -49.28)"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M512.28,482.47s8.66-4.5,12-4.25,33.33,38.39,33.33,38.39Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M423.45,224.35s-15.83,6.76-15.41,11.43S423.45,224.35,423.45,224.35Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M415.74,246.45s-16.61,21.24-12.94,21.95S415.74,246.45,415.74,246.45Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M471.3,278.28s1.52,47.5-10.66,53.5Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M408,405.11s11.72-6.66,14.41-5.33S408,405.11,408,405.11Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M410.05,414.32s7.4.53,10.91-1S410.05,414.32,410.05,414.32Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M586.7,239.41s9.18,26.37,14.47,26.37",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M456.16,744.45s17.22-4.67,19.76,0S456.16,744.45,456.16,744.45Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M401.42,675.21s-4.29,6.57,1.38,8.57S401.42,675.21,401.42,675.21Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M515.8,583.53s13,11.58,19.14,11.92S515.8,583.53,515.8,583.53Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.84,109.11S943.65,104,953.57,163c0,0-2,10.43,7.48,15.17,0,0,.15-4.38,8.64-2.89a39.41,39.41,0,0,0,9.14.44A19.08,19.08,0,0,0,990,171.13h0s23.67-9.77,32.87-48.46c0,0,6.81-8.44,6.54-10.61l-14.21,6.07s4.86,10.25,1,18.77c0,0-.46-18.4-3.19-18-.56.09-7.39,3.55-7.39,3.55s8.36,17.86,2.05,30.83c0,0,2.4-22-4.65-29.54l-10,5.84s9.77,18.44,3.15,33.49c0,0,1.7-23.08-5.25-32.07l-9.06,7.07s9.17,18.18,3.58,30.66c0,0-.73-26.87-5.55-28.9,0,0-7.92,7-9.13,9.86,0,0,6.28,13.2,2.38,20.16,0,0-2.39-17.9-4.35-18,0,0-7.9,11.86-8.72,20,0,0,.34-12.1,6.81-21.13,0,0-7.64,1.31-12.1,6.27,0,0,1.23-8.39,14-9.12,0,0,6.52-9,8.27-9.55,0,0-12.75-1.06-20.48,2.36,0,0,6.81-7.91,22.82-4.31l9-7.3s-16.79-2.3-23.9.24c0,0,8.19-7,26.31-1.9l9.74-5.83s-14.31-3.08-22.83-2c0,0,9-4.85,25.68.41l7-3.13s-10.48-2.06-13.55-2.38-3.24-1.18-3.24-1.18a36.39,36.39,0,0,1,19.7,2.19S1028.1,110,1027.84,109.11Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#6c63ff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M860.73,97.8s-38-2.29-33.56,24.37c0,0-.89,4.71,3.38,6.85,0,0,.07-2,3.9-1.31a17.05,17.05,0,0,0,4.14.2,8.62,8.62,0,0,0,5-2.08h0s10.69-4.42,14.85-21.9c0,0,3.08-3.81,3-4.79L855,101.88s2.19,4.63.47,8.48c0,0-.21-8.31-1.45-8.12-.25,0-3.33,1.61-3.33,1.61s3.77,8.07.92,13.93c0,0,1.09-9.94-2.1-13.35L845,107.07s4.41,8.33,1.42,15.13c0,0,.77-10.43-2.37-14.49l-4.09,3.2s4.14,8.21,1.61,13.85c0,0-.33-12.14-2.5-13.06,0,0-3.58,3.16-4.13,4.46,0,0,2.84,6,1.08,9.11,0,0-1.08-8.09-2-8.13,0,0-3.57,5.36-3.94,9a19.4,19.4,0,0,1,3.08-9.54,10.72,10.72,0,0,0-5.47,2.83s.56-3.79,6.35-4.12c0,0,2.95-4.07,3.74-4.31,0,0-5.76-.49-9.26,1.06,0,0,3.08-3.57,10.31-2l4-3.3s-7.59-1-10.8.11c0,0,3.7-3.16,11.88-.86l4.41-2.63s-6.47-1.39-10.32-.89c0,0,4.06-2.19,11.61.18l3.14-1.41s-4.73-.93-6.12-1.08-1.46-.53-1.46-.53a16.51,16.51,0,0,1,8.9,1S860.85,98.22,860.73,97.8Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#6c63ff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.6,
    cy: 722.88,
    rx: 26.93,
    ry: 4.55,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.93,
    cy: 655.15,
    rx: 26.93,
    ry: 4.55,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 827.86,
    cy: 634.75,
    rx: 26.93,
    ry: 4.55,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.09,
    cy: 679.56,
    rx: 26.93,
    ry: 4.55,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.82,
    cy: 683.47,
    rx: 26.93,
    ry: 4.55,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.66,
    cy: 771.64,
    rx: 40.21,
    ry: 6.8,
    fill: "#6c63ff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M967.52,809.8a11.68,11.68,0,0,0,3.83-5.78c.5-2.3-.48-5-2.68-5.89-2.46-.94-5.09.76-7.08,2.48s-4.28,3.69-6.89,3.33a10.5,10.5,0,0,0,3.25-9.82,4.13,4.13,0,0,0-.91-2c-1.36-1.46-3.84-.83-5.47.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.3-.08-4.69-.1-7s-.65-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.08-4.94.15-6.53,1.86-2,2.12-1.47,5.69.25,8s4.35,3.8,6.77,5.42a14.89,14.89,0,0,1,4.83,4.61,3.83,3.83,0,0,1,.36.82h14.66A40.9,40.9,0,0,0,967.52,809.8Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#6c63ff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M295.72,617s5.5,7.18-2.53,18-14.65,20-12,26.76c0,0,12.12-20.14,22-20.42S306.57,629.14,295.72,617Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#6c63ff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M295.72,617a8.63,8.63,0,0,1,1.12,2.25c9.62,11.3,14.75,21.85,5.5,22.12-8.61.24-18.94,15.64-21.42,19.53a9.24,9.24,0,0,0,.29.89s12.12-20.14,22-20.42S306.57,629.14,295.72,617Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M305.93,626.18c0,2.53-.28,4.58-.63,4.58s-.63-2-.63-4.58.35-1.34.7-1.34S305.93,623.65,305.93,626.18Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffd037"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M309.44,629.2c-2.22,1.21-4.16,1.94-4.32,1.64s1.49-1.54,3.71-2.75,1.35-.33,1.51,0S311.66,628,309.44,629.2Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffd037"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M266.71,617s-5.5,7.18,2.53,18,14.65,20,12,26.76c0,0-12.11-20.14-22-20.42S255.86,629.14,266.71,617Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#6c63ff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M266.71,617a8.82,8.82,0,0,0-1.13,2.25c-9.62,11.3-14.74,21.85-5.5,22.12,8.62.24,18.95,15.64,21.43,19.53a7.16,7.16,0,0,1-.3.89s-12.11-20.14-22-20.42S255.86,629.14,266.71,617Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M256.49,626.18c0,2.53.29,4.58.64,4.58s.63-2,.63-4.58-.35-1.34-.7-1.34S256.49,623.65,256.49,626.18Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffd037"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M253,629.2c2.22,1.21,4.15,1.94,4.32,1.64s-1.5-1.54-3.72-2.75-1.34-.33-1.51,0S250.77,628,253,629.2Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#ffd037"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M258.24,660.88s15.36-.47,20-3.77,23.63-7.23,24.77-1.94,23.09,26.29,5.75,26.43-40.3-2.7-44.92-5.52S258.24,660.88,258.24,660.88Z",
    transform: "translate(-163.24 -49.28)",
    fill: "#a8a8a8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M309.06,679.76c-17.34.14-40.3-2.7-44.92-5.52-3.51-2.14-4.92-9.83-5.39-13.38l-.51,0s1,12.39,5.59,15.2,27.58,5.66,44.92,5.52c5,0,6.73-1.82,6.64-4.46C314.69,678.73,312.78,679.73,309.06,679.76Z",
    transform: "translate(-163.24 -49.28)",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.f327a0d6ba5f1fed5aaf1e18de92791d.svg";
export { ForwardRef as ReactComponent };